﻿export default class Tabs {
    constructor() {
        this.dom = {
            $: window.$,
            $window: $(window),
            $container: $('.nav-tab'),
            $pageTitle: $('.pageTitle'),
            $btnItem: $('.nav-tab__item'),
            $btnTab: $('.nav-tab__link'),
            $tabContents: $('.content-tab'),
            $moreInfo: $('.more-info'),
            $tabContentItem: $('.content-tab__item'),
            $calcPanel: $('.calc-panel'),
            $calcButton: $('a.btn-rounded:contains("Złóż wniosek")'),
            $calcContiner: $('#calcContiner'),
            $sectionCalc: $('section.calc'),
            $bannerButton: $('.banner-apply-btn')
        };

        if (this.dom.$container.length) {
            this.init();
        }
    }

    init() {
        this.events();
    }

    events() {
        let $thisDom = this.dom;

        //Insert calculator into correct container
        if ($thisDom.$sectionCalc.length > 0 && $thisDom.$calcContiner.length > 0) $thisDom.$calcContiner.append($thisDom.$sectionCalc);

        let offset = 20 + (window.innerWidth < '993' ? 60 : 0);

        this.dom.$moreInfo.on('click', (e) => {
            e.preventDefault();
            //Move page up to top of tabs
            window.scrollTo({ top: $thisDom.$pageTitle.offset().top - offset, behavior: 'smooth' });
        });

        this.dom.$bannerButton.on('click', (e) => {
            e.preventDefault();
            let $clickedBtn = $(e.currentTarget);
            let linkHref = $clickedBtn.attr('href');
            if (!$(linkHref).is(':visible')) {
                let $tabHref = $(linkHref).closest($thisDom.$tabContentItem);
                if ($tabHref.length > 0) {
                    this.dom.$btnItem.find('[href="#' + $tabHref.attr('id') + '"]').parent().trigger('click');
                }
            }
            //Move page up to top of tabs
            window.scrollTo({ top: $(linkHref).offset().top - offset, behavior: 'smooth' });
        });

        this.dom.$btnItem.on('click', (e) => {
            e.preventDefault();
            let $clickedBtn = $(e.currentTarget);

            $thisDom.$btnItem.removeClass('active');
            $clickedBtn.addClass('active');
            $clickedBtn[0].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });

            let href = $clickedBtn.find('a').attr('href').substring(1);

            $thisDom.$tabContents.children('div.active').removeClass('active show');
            $thisDom.$tabContents.children('#' + href).addClass('active show');

            //Move page up to top of tabs
            if ($('.dual-calc-tab').length == 0) {
                window.scrollTo({ top: $thisDom.$container.offset().top - offset, behavior: 'smooth' });
            }
        });

        this.dom.$calcButton.on('click', (e) => {
            e.preventDefault();

            //Move page up to top of the calculator
            window.scrollTo({ top: $thisDom.$calcPanel.offset().top - offset, behavior: 'smooth' });
        });
    }
}

document.addEventListener('DOMContentLoaded', () => new Tabs());